import React from 'react';
import { Star, Award, Scale, Map, Lock } from 'lucide-react';
const ITEMS = [{
  icon: Star,
  label: '5 Star Google Rating'
}, {
  icon: Award,
  label: '40+ years combined experience'
}, {
  icon: Scale,
  label: 'Qualified solicitors'
}, {
  icon: Map,
  label: 'Australia-wide service'
}, {
  icon: Lock,
  label: 'Confidential document handling'
}];
export function TrustBar() {
  return <section className="px-5 md:px-6 pb-4 md:pb-8 bg-background" data-id="element-392" data-mp="11mnenl74zofi">
      <div className="max-w-7xl mx-auto" data-id="element-393" data-mp="16eyi2y135sct">
        <ul className="grid grid-cols-2 sm:grid-cols-5 gap-px rounded-2xl overflow-hidden border border-border bg-border" data-id="element-394" data-mp="16grm05kbdyh4">
          {ITEMS.map(item => {
          const Icon = item.icon;
          return <li key={item.label} className="flex items-center justify-center gap-2.5 bg-surface px-4 py-4 text-center last:col-span-2 sm:last:col-span-1" data-id="element-395" data-mp="ip43aax7htpx">
                <Icon className="w-4 h-4 text-peach-dark shrink-0" data-id="element-396" data-mp="3dv5ou1zte3me" />
                <span className="text-xs md:text-sm font-medium text-ink leading-snug" data-id="element-397" data-mp="3dtck4s8rhth1">
                  {item.label}
                </span>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}